import {Layout, Menu} from 'antd';

import './layout.css'
import ProfileDropdown from "./ProfileDropdown";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import ApiService from "../../../services/ApiService";
import {v4} from "uuid";
import {useAppContext} from "../../../context/AppContext";

const {Header} = Layout;

const {SubMenu} = Menu;
export default function MainLayout({children}) {
    const {t} = useTranslation();
    const [version, setVersion] = useState('')
    const history = useHistory();
    const location = useLocation()
    const [key, setKey] = useState(v4())
    const {selectedTab} = useAppContext()

    const getVersion = async () => {
        const res = await ApiService.RasCheck.GetVersion();
        if (res.success) {
            setVersion(res.data)
            window.rasVersion = res.data
        }
    }

    useEffect(() => {
        getVersion()
    }, [])

    useEffect(() => {
        setKey(v4())
    }, [location]);

    return (
        <>
            <div
                key={key}
                style={{
                display: 'flex',
                alignItems: 'center',
                alignContent: 'space-between',
                backgroundColor: '#035781',
                position: 'fixed',
                width: '100%',
                zIndex: 10
            }}>
                {/*<Logo/>*/}
                <Menu
                    style={{flex: 1}}
                    onClick={(item) => {
                        history.push(item.key)
                    }}
                    theme="dark"
                    mode="horizontal"
                    defaultSelectedKeys={[location.pathname]}
                >
                    {
                        (<Menu.Item key={'/app/load-project'}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={'/icons/Upload.svg'} width={16} height={16}
                                     style={{marginRight: 4}}/> {t('Upload')}
                            </div>
                        </Menu.Item>)
                    }
                    {
                        (<Menu.Item key={'/app/run'}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={'/icons/Check.svg'} width={16} height={16}
                                     style={{marginRight: 4}}/> {t('Run')}
                            </div>
                        </Menu.Item>)
                    }
                    {/*{*/}
                    {/*    (<Menu.Item key={'/app/comparison-check'}>*/}
                    {/*        <div style={{display: 'flex', alignItems: 'center'}}>*/}
                    {/*            <img src={'/icons/compare.svg'} width={16} height={16}*/}
                    {/*                 style={{marginRight: 4}}/> {t('compare')}*/}
                    {/*        </div>*/}
                    {/*    </Menu.Item>)*/}
                    {/*}*/}
                    {
                        (<Menu.Item key={'/app/messages'}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={'/icons/Report.svg'} width={18} height={18}
                                     style={{marginRight: 4}}/> {t('Message')}
                            </div>
                        </Menu.Item>)
                    }
                    {
                        (<Menu.Item key={'/app/profile/settings'}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={'/icons/Settings.svg'} width={16} height={16}
                                     style={{marginRight: 4}}/> {t('Settings')}
                            </div>
                        </Menu.Item>)
                    }
                    {
                        (<Menu.Item key={'/app/help'}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img src={'/icons/How_to.svg'} width={24} height={24}
                                     style={{marginRight: 4}}/> {t('How to')}
                            </div>
                        </Menu.Item>)
                    }
                </Menu>
                <ProfileDropdown/>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'space-between',
                height: '100%',
                marginTop: 48
            }}>
                <div style={{flex: 1}}>
                    {children}
                </div>
                {
                    ((selectedTab !== 'Map' && location.pathname === '/app/messages') || location.pathname !== '/app/messages') && (
                        <div
                            id={'footer-div'}
                            style={{
                                textAlign: 'left',
                                marginLeft: 8,
                                paddingTop: 0,
                                padding: 0,
                                backgroundColor: '#e6eef2',
                            }}>
                            Copyright (c) {new Date().getFullYear()} RAS Review {version}<br/> Free Research Preview
                        </div>
                    )
                }
            </div>
        </>
    )
}
